import { TranslationKeys } from "../types";
import { SITE_CONFIG } from "../../app/config";

export const pl: TranslationKeys = {
  hero: {
    title1: "NAPRAWDĘ TWOJA",
    title2: "MUZYKA",
    streamingRenting: "STREAMING",
    vinylCdForever: "WINYL & CD",
    description: `Wklej playlistę Spotify. Zgarnij listę zakupów winyli i CD. Na własność. Zbuduj swoją fizyczną kolekcję.`,
    ctaName: SITE_CONFIG.name,
  },
  
  perks: {
    ownIt: {
      title: "Twoje Na Serio",
      desc: "Bez subskrypcji. Bez znikania. Płacisz raz, masz na zawsze. Prawdziwa własność.",
    },
    quality: {
      title: "Jakość Winyl & CD",
      desc: "Analogowe ciepło lub cyfrowa perfekcja. Fizyczne wydanie to inny klimat.",
    },
    collection: {
      title: "Pochwal Się Kolekcją",
      desc: "Półka marzeń. Sztuka na ścianie. Temat do rozmów. Prawdziwa kolekcja do pokazania.",
    },
  },
  
  form: {
    placeholder: "https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M",
    go: "START",
    tryExample: "Nie masz playlisty? Wyprobuj przyklad",
    errors: {
      emptyPlaylist: "Wklej link do playlisty Spotify, żeby zacząć.",
      cloudflareCheck: "Potwierdź, że nie jesteś robotem (Cloudflare).",
      cloudflareValidation: "Weryfikacja nieudana. Spróbuj jeszcze raz.",
    },
  },
  
  results: {
    scanning: "SKANUJĘ PLAYLISTĘ",
    yourHaul: "TWÓJ ŁUP: WINYLE & CD",
    playlist: "Playlista",
    tracksToAlbums: "utworów → albumów na własność",
    track: "utwór",
    tracks: "utworów",
    oops: "UPS!",
    unableToProcess: "Nie udało się przetworzyć playlisty.",
    noAlbumsFound: "BRAK ALBUMÓW",
    noAlbumsDesc: "Nic nie znaleziono dla tej playlisty!",
    tryDifferent: "Spróbuj innej playlisty z większą liczbą kawałków.",
    albumsToOwn: "ALBUMY NA WŁASNOŚĆ",
    comingSoon: "Wkrótce",
    ownIt: "KUP TERAZ →",
  },
  
  share: {
    shareHaul: "🔥 UDOSTĘPNIJ ŁUP",
    linkCopied: "🔗 LINK SKOPIOWANY!",
    shared: "🚀 POSZŁO W ŚWIAT!",
    shareText: `🔥 Buduję kolekcję winyli i CD! Zobacz mój łup z "{playlistName}" 💿🎵 #kolekcjawinyli #kolekcjacd #mojamuzyka`,
  },
  
  affiliate: {
    disclosure: "Info o partnerstwie:",
    disclosureText: `${SITE_CONFIG.name} jest w programie partnerskim ${SITE_CONFIG.affiliatePartner}. Zarabiamy na zakupach z naszych linków, bez kosztów dla Ciebie. To pozwala utrzymać ${SITE_CONFIG.name} za darmo!`,
    notice: `Info: Linki poniżej to linki partnerskie. Możemy dostać prowizję, a Ty nie płacisz więcej. Dzięki za wsparcie ${SITE_CONFIG.name}!`,
  },
  
  faq: {
    title: "Częste Pytania",
    subtitle: "WSZYSTKO O POSIADANIU SWOJEJ MUZYKI.",
    sponsored: "Sponsorowane",
    adTitle: "Odkryj Sprzęt Muzyczny",
    adDesc: "Gramofony premium, stojaki na CD i więcej",
    items: [
      {
        question: `Jak działa ${SITE_CONFIG.name}?`,
        answer: "Wklej dowolny publiczny link do playlisty Spotify w GoOffline. Skanujemy każdy utwór, dopasowujemy go do fizycznych wydań — winyle, płyty CD i kasety — i pokazujemy, gdzie je kupić z prawdziwymi cenami z Discogs. Jeden klik od streamingu do posiadania.",
      },
      {
        question: `Czy ${SITE_CONFIG.name} jest darmowy?`,
        answer: "Tak, GoOffline jest całkowicie darmowy. Bez rejestracji, bez subskrypcji, bez ukrytych opłat. Zarabiamy niewielką prowizję, gdy kupujesz przez nasze linki partnerskie — Ciebie to nic nie kosztuje, a nam pozwala utrzymać narzędzie.",
      },
      {
        question: "Czy potrzebuję konta Spotify lub logowania?",
        answer: "Żadne konto ani logowanie nie jest potrzebne. Po prostu wklej publiczny link do playlisty Spotify lub URL udostępniania. Nigdy nie uzyskujemy dostępu do Twojego konta Spotify — czytamy tylko utwory z playlisty, którą udostępniasz.",
      },
      {
        question: "Jakie formaty muzyczne mogę znaleźć — winyl, CD czy kaseta?",
        answer: "GoOffline wyszukuje winyle, płyty CD i kasety magnetofonowe. Każda karta albumu pokazuje, które formaty są dostępne, wraz z aktualnymi cenami rynkowymi. Winyl i CD są najczęściej spotykane, dostępność kaset zależy od tytułu.",
      },
      {
        question: "Czy działa z prywatnymi playlistami Spotify?",
        answer: "Obecnie obsługiwane są tylko publiczne playlisty. Szybkie obejście: ustaw playlistę jako publiczną, zeskanuj ją na GoOffline, a potem przełącz z powrotem na prywatną. Zajmuje to około 10 sekund.",
      },
      {
        question: "Skąd bierzecie ceny?",
        answer: "Wszystkie ceny pochodzą z Discogs, największego na świecie marketplace'u winyli i CD z ponad 80 milionami ogłoszeń. Pokazujemy szacunkowe ceny oparte na prawdziwych danych rynkowych, abyś miał wiarygodny punkt odniesienia przed zakupem.",
      },
      {
        question: "Jak dokładne są ceny winyli i CD?",
        answer: "Ceny są szacowane na podstawie najnowszych danych z marketplace Discogs i odzwierciedlają realne warunki rynkowe. Rzeczywista cena może się różnić w zależności od tłoczenia, stanu i sprzedawcy. Traktuj to jako wiarygodny punkt wyjścia do planowania budżetu na kolekcję.",
      },
      {
        question: "Czy mogę udostępnić moją listę zakupów winyli i CD?",
        answer: "Tak! Kliknij przycisk udostępniania, by wysłać swój łup znajomym lub wrzucić go na media społecznościowe. Każdy wynik ma unikalny link do udostępnienia. Dzielenie się pomaga nam pozostać darmowymi i pomaga Twoim znajomym odkryć muzykę fizyczną.",
      },
      {
        question: "Co jeśli album nie zostanie znaleziony?",
        answer: "GoOffline działa najlepiej ze znanymi wydaniami — klasyczny rock, jazz, hip-hop, hity pop i katalogi legend mają najwyższe wskaźniki dopasowania. Nowsze wydania indie lub wyłącznie cyfrowe mogą nie mieć jeszcze fizycznych tłoczeń. Im bardziej kultowy album, tym lepsze wyniki.",
      },
      {
        question: "Po co kupować winyle lub CD w 2026?",
        answer: "Sprzedaż winyli rośnie od 18 lat z rzędu i osiąga rekordowe wartości. CD również wracają do łask, oferując bezstratną jakość dźwięku w atrakcyjnych cenach. Fizyczna muzyka to prawdziwa własność — żadnych subskrypcji, żadnych znikających katalogów i realna obecność na półce.",
      },
      {
        question: "Winyl vs CD — który format wybrać?",
        answer: "Winyl oferuje ciepły analogowy dźwięk, wartość kolekcjonerską, duże 12-calowe okładki i świetnie wygląda na wystawie. CD są tańsze, przenośne, zapewniają idealną jakość cyfrowego dźwięku i są łatwiejsze do znalezienia. Oba są lepsze niż płacenie co miesiąc za muzykę, która może zniknąć z platform streamingowych.",
      },
      {
        question: `Czy ${SITE_CONFIG.name} jest powiązany ze Spotify?`,
        answer: "Nie. GoOffline to niezależne narzędzie stworzone dla fanów muzyki, którzy chcą posiadać swoją kolekcję. Korzystamy z publicznego API Spotify do odczytu danych playlist, ale nie jesteśmy w żaden sposób wspierani ani powiązani ze Spotify.",
      },
      {
        question: `Czy moje dane są prywatne i bezpieczne na ${SITE_CONFIG.name}?`,
        answer: "Absolutnie. Nie wymagamy żadnego logowania ani danych osobowych. Czytamy jedynie dane utworów z publicznego URL playlisty, który podajesz. Żadnych ciasteczek śledzących, żadnej sprzedaży danych. Twoja prywatność jest w pełni szanowana.",
      },
      {
        question: "Dlaczego warto posiadać fizyczną muzykę zamiast streamingu?",
        answer: "Serwisy streamingowe mogą usuwać albumy bez uprzedzenia, gdy wygasają licencje. Fizyczna muzyka jest Twoja na zawsze — żadnych algorytmów decydujących co słuchasz, żadnego zmęczenia subskrypcjami, żadnych korporacyjnych decyzji kontrolujących Twoją bibliotekę. A nic nie zastąpi rytuału kładzenia igły na winyl czy trzymania okładki albumu w dłoniach.",
      },
    ],
  },
  
  footer: {
    affiliateDisclosure: "Partnerstwo:",
    copyright: `© ${new Date().getFullYear()} ${SITE_CONFIG.name} — Konwerter Spotify na Winyl i CD`,
    converter: "Konwerter Spotify na Winyl i CD",
    terms: "Regulamin",
    privacy: "Prywatność",
    affiliateLink: "Partnerstwo",
    notAffiliated: "Nie powiązane ze Spotify",
  },
  
  ad: {
    label: "REKLAMA",
    title: "Twoja Reklama Tutaj",
    desc: "Responsywna reklama · 728×90 lub podobna",
  },
  
  language: {
    label: "Język",
    en: "English",
    fr: "Français",
    de: "Deutsch",
    pl: "Polski",
  },
};
